import { useEffect } from "react";
import type { RefObject } from "react";
import type { GridApi } from "ag-grid-community";

export function useTableAutoSize(
  gridRef: RefObject<GridApi | null>,
  containerRef: RefObject<HTMLDivElement | null>,
  view: string,
  lastColumnField: string | null
) {
  useEffect(() => {
    if (
      view === "table" &&
      gridRef.current &&
      lastColumnField
    ) {
      const timeoutId = setTimeout(() => {
        autoSizeColumns(gridRef.current, lastColumnField, view);
      }, 150);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [view, lastColumnField, gridRef]);

  useEffect(() => {
    if (!containerRef.current || view !== "table" || !lastColumnField) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      if (gridRef.current) {
        setTimeout(() => {
          autoSizeColumns(gridRef.current, lastColumnField, view);
        }, 50);
      }
    });

    resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [view, lastColumnField, gridRef, containerRef]);
}

export function autoSizeColumns(
  api: GridApi | null,
  lastColumnField: string | null,
  view: string
) {
  if (!api || api.isDestroyed() || view !== "table" || !lastColumnField) {
    return;
  }

  const allColumns = api.getColumns();
  if (!allColumns) return;

  const columnsToAutoSize = allColumns
    .filter((col: any) => col.getColId() !== lastColumnField)
    .map((col: any) => col.getColId());

  if (columnsToAutoSize.length > 0) {
    api.autoSizeColumns(columnsToAutoSize, false);
  }
}

